import React, { useEffect, useState, useRef } from "react";
import { useContext } from "react";
import { CarrierContext } from "../contexts/CarrierContext";
import { LanguageContext } from "../contexts/LanguageContext";
import { Form, useNavigate, Link } from "react-router-dom";

// Mobile Breakpoint Constant (phones only, excludes tablets)
const MOBILE_BREAKPOINT = 767;

const HeaderPayment = ({ page, setLangSelected }) => {
  const carrierContxt = useContext(CarrierContext);
  const { cmsAllPages, handleLanguage, langErr } = useContext(LanguageContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier") // Set URL in carrier
    ? carrierContxt.carrier
    : null;
  const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();

  const baseUrl = process.env.PUBLIC_URL;
  const navigate = useNavigate();
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const storedLang = sessionStorage.getItem("langSel");
    return storedLang ? storedLang : "eng"; // Use stored value if present, else default to 'eng'
  });
  const [cms, setCMS] = useState("");

  useEffect(() => {
    if (cmsAllPages && cmsAllPages[page]) {
      setCMS(cmsAllPages[page]);
    }
  }, [cmsAllPages, setCMS, page, selectedLanguage]);
  const handleLogout = () => {
    const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
    // Clear authentication-related data
    if (
      process.env[carr_code] &&
      sessionStorage.getItem("userData_" + process.env[carr_code])
    ) {
      sessionStorage.removeItem("userData_" + process.env[carr_code]);
    }

    if (sessionStorage.getItem("langSel")) {
      sessionStorage.removeItem("langSel");
    }
    if (sessionStorage.getItem("nacha_" + urlCarrier)) {
      sessionStorage.removeItem("nacha_" + urlCarrier);
    }
    if (sessionStorage.getItem("sessionId")) {
      sessionStorage.removeItem("sessionId");
    }
    if (urlCarrier) {
      window.location.replace("/" + urlCarrier);
      //navigate("/" + urlCarrier);
    } else {
      const urlCarrier = carrierContxt.hasOwnProperty("carrier") // Set URL in carrier
        ? carrierContxt.carrier
        : "";
      window.location.replace("/" + urlCarrier);
      //navigate("/" + urlCarrier);
    }
  };
  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
    sessionStorage.setItem("langSel", event.target.value); // Store selected language
    handleLanguage(event.target.value);
    setLangSelected(event.target.value); //this is to change nacha content in makepayment
  };

  const [menuToggle, setMenuToggle] = useState(false);
  const menuContainerRef = useRef(null);

  // bcbsaz Mobile Detection (phones only, excludes tablets)
  const isBcbsazCarrier = urlCarrier === 'bcbsaz';

  const handleMenu = () => {
    setMenuToggle(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuToggle &&
        menuContainerRef.current &&
        !menuContainerRef.current.contains(event.target)
      ) {
        const menuButton = document.querySelector('[aria-label="Open menu"]');
        if (!menuButton?.contains(event.target)) {
          setMenuToggle(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuToggle]);

  return (
    <header
      id="header"
      className="header fixed-top d-flex align-items-center ps-xl-2 ps-md-2 ps-sm-2 ps-0"
    >
      <div className="d-flex align-items-center justify-content-between col-xl-8 col-md-8 col-sm-7 col-6">
        <a
          href={`${baseUrl}/${urlCarrier}`}
          className="logo d-block align-items-center text-left"
        >
          <span className="ms-xl-4 ms-md-4 ms-sm-4 ms-2">
            <img
              src={`${process.env.PUBLIC_URL}/images/carrier-logos/${urlCarrier}-sml.svg`}
              alt={cms?.carrier_logo_508_alt_text}
              className="header-logo-img"
              tabIndex="0"
            />
          </span>
        </a>
      </div>

      <div className="d-flex align-items-center col-xl-4 col-md-4 col-sm-5 col-6">
        {/* <ul class="navbar-nav mb-2 mb-lg-0 float-end col-9">
          <li class="nav-item dropdown mt-3">
            <a
              class="nav-link dropdown-toggle language-dropdown text-center"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span class="h6 fw-semibold">English</span>
            </a>
            <ul class="dropdown-menu dropdown-menus">
              <li class="dropdown-item hvr-bounce-to-right">Spanish</li>
            </ul>
          </li>
        </ul>*/}
        <div className="d-flex align-items-center gap-2 gap-xl-4 ms-auto me-xl-4 pe-3">
          <select
            id="language"
            className="dropdown-menus exclude-in-print"
            value={selectedLanguage}
            onChange={handleLanguageChange}
          >
            <option value="eng" className="en-flag">
              {cms?.label_english}
            </option>
            <option value="spa" className="es-flag">
              {cms?.label_spanish}
            </option>
          </select>

          <nav role="navigation" className="exclude-in-print">
          <div id="menuToggle">
            <button
              onClick={handleMenu}
              style={{ border: "none", background: "transparent", padding: 0 }}
              aria-label="Open menu"
              aria-expanded={menuToggle}
              tabIndex={0}
            >
              {urlCarrier === 'bcbsaz' ? (
                <img
                  src={`${process.env.PUBLIC_URL}/images/icons/Menu-bcbsaz.svg`}
                  alt="Menu"
                  className="menu-icon-bcbsaz"
                />
              ) : (
                <>
                  <span></span>
                  <span></span>
                  <span></span>
                </>
              )}
            </button>
            <ul id="menu" ref={menuContainerRef} className={menuToggle ? "open" : ""}>
              <button
                type="button"
                className="logout-btn mb-4 d-block text-decoration-none"
                onClick={handleLogout}
              >
                <i className="fe fe-log-out ms-2 blue-icons fe-18 logout-icon"></i>{" "}
                {cms?.label_logout || "Logout"}
              </button>

              {!isBcbsazCarrier && (
                <>
                  <a
                      href={
                        cms?.limited_english_proficiency_link && cms.limited_english_proficiency_link.trim() !== ""
                            ? `${cms?.limited_english_proficiency_link}`
                            : `${baseUrl}/${urlCarrier}/language_proficiency`
                      }
                    className="text-decoration-none"
                    rel="noopener noreferrer"
                  >
                    <li>{cms?.limited_english_proficiency_link_name}</li>
                  </a>
                  <a
                      href={
                        cms?.non_discrimination_notice_link && cms.non_discrimination_notice_link.trim() !== ""
                            ? `${cms?.non_discrimination_notice_link}`
                            : `${baseUrl}/${urlCarrier}/language_proficiency`
                      }
                    className="text-decoration-none"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <li>{cms?.non_discrimination_notice_link_name}</li>
                  </a>
                  <a
                    href={`/${urlCarrier}/contact_us`}
                    className="text-decoration-none"
                  >
                    <li>{cms?.contact_us_link_name}</li>
                  </a>
                  <a
                  href={
                    cms?.faq_link && cms.faq_link.trim() !== ""
                        ? `${cms?.faq_link}`
                        : `${baseUrl}/${urlCarrier}/faq`
                  }
                className="text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                <li>{cms?.faq_link_name}</li>
              </a>
                  <a
                    href={`/${urlCarrier}/glossary`}
                    className="text-decoration-none"
                  >
                    <li>{cms?.glossary_acrn_link_name}</li>
                  </a>
                </>
              )}
            </ul>
          </div>
        </nav>
        </div>
      </div>
    </header>
  );
};

export default HeaderPayment;
